import React from 'react';
const MySpinner = () => {
  return <div className="spinner"></div>;
};

export default MySpinner;
